import _ from 'underscore';

// Took the regex from https://emailregex.com/ (RFC 5322 Official Standard)
export function getEmailRegExp(domainName?: string): RegExp {
  // front half of the regexp matches everything up to the @ symbol
  const frontRegExp =
    '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@';
  const backRegExp =
    '(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])';
  return RegExp(`${frontRegExp + (domainName ?? backRegExp)}$`);
}

// Logic from email_util.py
const DISALLOWED_EMAIL_CHARACTERS = [' ', ';', ','];

export default function isValidEmail(email: string): boolean {
  if (_.any(DISALLOWED_EMAIL_CHARACTERS.map((invalidChar) => email.includes(invalidChar)))) {
    return false;
  }
  if ((email.match(/@/g) || []).length !== 1) {
    return false;
  }
  return getEmailRegExp().test(String(email).toLowerCase());
}
